var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZigzagline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 7,
    viewBox: "0 0 343 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.003c8.021 3.333 15.966 5 23.836 5 11.804 0 11.804-5 23.382-5 11.577 0 11.577 5 22.928 5 11.35 0 11.18-5 22.473-5 11.294 0 11.221 5 22.701 5s12.04-5 23.22-5 9.978 5 21.501 5c11.523 0 12.845-5 24.593-5 11.747 0 11.226 5 22.398 5 11.171 0 11.165-5 22.288-5 11.123 0 11.014 5 22.205 5 11.192 0 11.114-5 22.562-5 11.447 0 11.844 5 23.23 5 11.385 0 10.89-5 22.311-5 7.614 0 15.405 1.666 23.372 5",
    stroke: "#AAA",
    fill: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzagline);
export default __webpack_public_path__ + "static/media/zigzagline.1a263d867784c1b701a3227a6769a223.svg";
export { ForwardRef as ReactComponent };